import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./socialMediaOverlayStyle.css";
import "aos/dist/aos.css";

export default function SocialMediaOverlay() {
    const navigate = useNavigate();

    useEffect(() => {
    }, []);

    function openNewTab(side) {
        window.open(side)
    }

    return (
        <div className="socialMediaOverlayContainer">
            <img className="facebookImage" onClick={() => openNewTab("https://www.facebook.com/deejay.elmar")} src="/img/facebook.svg" />
            <img className="instagramImage" onClick={() => openNewTab("https://www.instagram.com/djelmarfichtner/")} src="/img/instagram.svg" />
        </div>
    )
}
